<template>
  <div class="pc_banner">
              <div class="box" id="pc_banner_line" >
              <!--   arrow="always/hover/never"     type="—" direction="vertical"  indicator-position="outside" -->
                  <el-carousel
                  :interval="5000"
                  arrow="never"
                  indicator-position="none"
                  :height="vbannerlistsheight"
                  style="background: none; margin: 0;   padding: 0; text-align: center; border: 0px; overflow: hidden; ">
                      <el-carousel-item v-for="(item,index) in vbannerlists" :key="index"  style="background: none;    "   >
                         <!-- <h3>{{ item }}</h3> -->

    <!--                      <div class="pc_banner_line_div"  :style="` background: none; overflow: hidden; height:${vbannerlistsheight}; text-align:center; ` "> -->
                            <!--
                                <div class="pc_banner_line_bg"
                                v-if="item.img"  :style="`background:url(${item.img})  ;
                                background-size: 100%; `" >{{ item.name }}</div>
                            -->
             <!--                <div class="pc_banner_line_bg"  style="background: #FFFFFE ;" >&nbsp;</div> -->

<!--                         <div class="pc_banner_line_img"  > -->
                             <a :href="item.href" target="_blank"  style="margin: 0; padding: 0;"  >
                                    <img
                                     height="100%" v-lazy="item.img" style=" "
                                    :data-src="item.img"
                                    :title="item.name"
                                    :alt="item.name" />
                            </a>

<!--
                            <div class="pc_banner_line_name"  v-if="item.name"   >
                                 <a :href="item.href" target="_blank"  style="margin: 0; padding: 0;"  >
                                     <span>{{ item.name }}</span>
                                 </a>
                             </div>
                             -->
<!--                         </div>
                         </div> -->
                      </el-carousel-item>
                    </el-carousel>

              </div>

  </div>

</template>

<script>
export default {
name: "Banner",
data(){
return {

  //  height:'',//300px'

}
},

props: [
'vbannerlists',
'vbannerlistsheight'
],


    // title: {
    //   type: String,
    //   default: ""
    // },
    // img: {
    //   type: String,
    //   default: "../../../assets/login-bg-2.jpg"
    // }
   // props: {}
};
</script>

<style   scoped>
    .el-carousel__item{ background-color: red;}
    .el-carousel__item h3 {
        color: red;
        font-size: 68px;
     /*   opacity: 0.75; */
        line-height: 300px;
        height: 300px;
        margin: 0;
      }



 .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }


.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }


.el-carousel__container { background-color: red;}
.el-carousel__container .el-carousel__arrow {
    background: red;
}
/* button.el-carousel__arrow {
    border: none;
        outline: 0;
        padding: 0;
        margin: 0;
        height: 100px;
        width: 100px;
        cursor: pointer;
        -webkit-transition: .3s;
        transition: .3s;
        border-radius: 50%;
        background-color: rgba(31,45,61,9.11);
        color: #FFF;
        position: absolute;
        top: 50%;
        z-index: 10;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        text-align: center;
        font-size: 0.16rem;
} */
</style>



// WEBPACK FOOTER //
// src/components/page/tmp/pc/banner.vue